var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuizzes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_21492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.22729 17.7865V5.27739C9.22729 3.25769 10.8182 1.62891 12.7909 1.62891H37.1637C39.1364 1.62891 40.7273 3.25769 40.7273 5.27739V19.6107C40.7273 21.6304 39.1364 23.2592 37.1637 23.2592H36.0818V28.4713L30.9909 23.2592H22.9091",
    stroke: "#4DABC7",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0091 15.5063C24.3727 15.5063 23.8 14.9851 23.8 14.2684V13.226C23.8 11.923 24.5636 10.7502 25.6454 10.2942C26.3454 10.0336 26.8545 9.25174 26.7909 8.46992C26.7909 7.49265 25.9636 6.58053 24.9454 6.58053C24.4363 6.58053 23.9909 6.77598 23.6091 7.10174C23.2273 7.49265 23.0363 7.94871 23.0363 8.46992C23.0363 9.12144 22.5273 9.7078 21.8273 9.7078C21.1273 9.7078 20.6182 9.18659 20.6182 8.46992C20.6182 7.29719 21.0636 6.18962 21.8909 5.4078C22.7182 4.56083 23.8 4.16992 24.9454 4.16992C27.2363 4.16992 29.0818 6.12447 29.0818 8.40477C29.0818 10.1639 28.0636 11.7927 26.4091 12.5093C26.1545 12.5745 26.0273 12.9002 26.0273 13.1608V14.2033C26.1545 14.9851 25.6454 15.5063 25.0091 15.5063ZM26.4091 18.9593C26.4091 19.7411 25.7727 20.4578 24.9454 20.4578C24.1818 20.4578 23.4818 19.8063 23.4818 18.9593C23.4818 18.1775 24.1182 17.4608 24.9454 17.4608C25.7727 17.4608 26.4091 18.1123 26.4091 18.9593Z",
    fill: "#273861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9182 17.5259C6.49089 17.5259 1.27271 22.8683 1.27271 29.4486C1.27271 31.7941 1.97271 34.0092 3.11816 35.8335L2.09998 41.3713L8.01816 40.2638C9.4818 40.9804 11.1363 41.3713 12.9182 41.3713C19.3454 41.3713 24.5636 36.0289 24.5636 29.4486C24.5636 22.8683 19.3454 17.5259 12.9182 17.5259Z",
    stroke: "#273861",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6454 31.4684L11.009 22.3472H14.8272L14.2545 31.4684H11.6454ZM14.3818 35.0517C14.3818 35.8335 13.7454 36.5502 12.9181 36.5502C12.1545 36.5502 11.4545 35.8987 11.4545 35.0517C11.4545 34.2047 12.0909 33.5532 12.9181 33.5532C13.7454 33.6184 14.3818 34.2699 14.3818 35.0517Z",
    fill: "#4DABC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_21492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizzes);
export default __webpack_public_path__ + "static/media/quizzes.092b8e13a5959e589b31e5c47ed2b430.svg";
export { ForwardRef as ReactComponent };